import { z } from "zod"

export enum CouponType {
  PERCENT = "PERCENT",
  DIRECT = "DIRECT",
}

export const CouponDtoSchema = z.object({
  value: z.number(),
  type: z.nativeEnum(CouponType),
  duration: z.number().nullable(),
  createdAt: z.string().datetime(),
})

export const CouponInputSchema = z.object({
  durationInMonths: z.number().nullable(),
  type: z.nativeEnum(CouponType),
  value: z.number(),
})

export type CouponDto = z.infer<typeof CouponDtoSchema>
export type CouponInput = z.infer<typeof CouponInputSchema>
